export default __webpack_public_path__ + "static/media/appEdit.ec1162ca.svg";